
export async function handleStep(dispatch, activeStep) {
    if (activeStep === 0) {
        dispatch({ type: "STEP_1" });
    }
    else if (activeStep === 1) {
        dispatch({ type: "STEP_2" });
    }
    else if (activeStep === 2) {
        dispatch({ type: "STEP_3" });
    }
    else if (activeStep === 3) {
        dispatch({ type: "STEP_4" });
    }
    else if (activeStep === 4) {
        dispatch({ type: "STEP_5" });
    }
    else if (activeStep === 5) {
        dispatch({ type: "STEP_6" });
    }
}

export function setAccessNextStep(dispatch, access = false) {
    dispatch({ type: 'ACCESS_NEXT', access: access });
}

export function setAllMovementData(dispatch, payload) {
    // step 1 data
    const { file, img2, img1, training_voice, important_points_voice } = payload;
    dispatch({ type: 'UPDATE_ALL_FILES', file, img2, img1, training_voice, important_points_voice });
    payload.equipments = payload.equipments.map(i => String(i));
    localStorage.setItem('createMovement', JSON.stringify(payload))
}